module.exports = __webpack_public_path__ + "static/media/blog5_3.d07a5ee5.webp";